/**
 * Which fitting room this phone last opened, so the home page can offer it back.
 *
 * The fitting room stays open after she books — she is meant to come back to
 * it — and the link is the only credential it has. Someone who taps the
 * boutique's address a week later should land on her own lists, not on a
 * button that starts a second, empty one beside them.
 *
 * Only the token, only here, and nothing she typed: the same link is already
 * in the phone's history and in the message it came in. Storage that is
 * blocked or full costs her the shortcut and nothing else.
 */
const KEY = 'fr:last-fitting-room'

export function rememberFittingRoom(token: string): void {
  try {
    window.localStorage.setItem(KEY, token)
  } catch {
    // Private mode, or storage switched off: the link still works.
  }
}

export function lastFittingRoom(): string | null {
  try {
    return window.localStorage.getItem(KEY)
  } catch {
    return null
  }
}

/** Forget it, but only if it is the one that stopped working. */
export function forgetFittingRoom(token: string): void {
  try {
    if (window.localStorage.getItem(KEY) === token) window.localStorage.removeItem(KEY)
  } catch {
    // Nothing to forget where nothing could be stored.
  }
}
